import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ZoomPan"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.2575 9L19.2 10.0575L21.135 12L19.1925 13.9425L20.2575 15L23.2575 12L20.2575 9ZM4.8075 10.065L3.75 9L0.75 12L3.75 15L4.815 13.9425L2.8725 12L4.8075 10.065ZM12 21.1275L10.0575 19.185L9 20.25L12 23.25L15 20.25L13.9425 19.1925L12 21.1275ZM12 2.8725L13.935 4.8075L15 3.75L12 0.75L9 3.75L10.0575 4.815L12 2.8725ZM16.4999 12C16.5016 9.92393 15.0828 8.11617 13.0658 7.62444C11.0488 7.13271 8.95718 8.08465 8.00318 9.92854C7.04918 11.7724 7.48043 14.0297 9.04699 15.392C10.6135 16.7543 12.9088 16.8682 14.6024 15.6675L17.4674 18.5325L18.5324 17.4675L15.6674 14.6025C16.208 13.8423 16.4989 12.9328 16.4999 12ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ZoomPan.vue"]]);
